module.exports = __webpack_public_path__ + "static/media/icon-rotate-left.c29f35c9.png";